<template>
  <div id="app">
    <div class="preloader" v-show="!$auth.ready()">
      <div class="container">
        <a-spin/>
        <h6>Loading</h6>
      </div>
    </div>
    <new-entry-modal :visible="entryModal" @cancel="hideEntryModal"></new-entry-modal>
    <notifications-drawer ref="notificationDrawer"></notifications-drawer>
    <div class="auth-wrapper" v-if="verifyUser()">
      <img
        src="@/assets/img/circle_drop.png"
        style="width:10%; position:absolute; right:-40px; bottom:-20px"
      >
      <img
        src="@/assets/img/circle_drop.png"
        style="width:10%; position:absolute; left:-40px; bottom:-20px"
      >
      <auth-nav></auth-nav>
      <router-view></router-view>
    </div>
    <a-layout v-else id="components-layout-demo-custom-trigger">
      <a-layout-sider class="outer-sidebar">
        <div class="menu-footer">
          <ul class="menu-icons">
            <li>
              <a-tooltip placement="rightTop">
                <template slot="title">
                  <span>Search Dashboard</span>
                </template>
                <i id="search-icon" class="zmdi zmdi-search left-sidebar-menu z-menu float-left"/>
              </a-tooltip>
            </li>
            <li @click="showEntryModal" v-show="isAdmin">
              <a-tooltip placement="rightTop">
                <template slot="title">
                  <span>Add New Entry</span>
                </template>
                <i id="search-icon" class="zmdi zmdi-plus left-sidebar-menu z-menu float-left"/>
              </a-tooltip>
            </li>
            <router-link :to="{name: 'account-show'}">
              <li class="bottom-menu bottom-240">
                <a-tooltip placement="rightTop">
                  <template slot="title">
                    <span>My Profile</span>
                  </template>
                  <img
                    src="@/assets/img/profilepic.jpeg"
                    style="height:30px; width:30px;border-radius:30px"
                  >
                </a-tooltip>
              </li>
            </router-link>

            <li @click="showServices" class="bottom-menu bottom-120">
              <a-tooltip placement="rightTop">
                <template slot="title">
                  <span>Switch Services</span>
                </template>
                <i id="services" class="zmdi left-sidebar-menu zmdi-dialpad z-menu float-left"/>
              </a-tooltip>
            </li>

            <li class="bottom-menu bottom-60">
              <a-tooltip placement="rightTop">
                <template slot="title">
                  <span>My Notifications</span>
                </template>
                <i
                  id="notifications"
                  class="zmdi left-sidebar-menu zmdi-notifications-none z-menu float-left"
                />
              </a-tooltip>
            </li>
            <li class="bottom-menu bottom-0" @click="logout">
              <a-tooltip placement="rightTop">
                <template slot="title">
                  <span>Logout</span>
                </template>
                <i id="signout" class="zmdi zmdi-sign-in z-menu left-sidebar-menu float-left"/>
              </a-tooltip>
            </li>
          </ul>
        </div>
      </a-layout-sider>
      <a-layout-sider class="inner-sidebar" :trigger="null" collapsible v-model="collapsed">
        <div class="logo">
          <img src="@/assets/logo.png" class="logo--img">

          <span
            style="cursor:pointer; float:right; margin-top:5px; border:1px dashed #E4E4E4; padding-top:5px;padding-bottom:5px;padding-left:7px;padding-right:7px"
          >
            <a-tooltip placement="rightTop">
              <template slot="title">
                <span>Switch to Dark Mode</span>
              </template>

              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="15"
                height="15"
                fill="#B4ABDC"
                viewBox="0 0 24 24"
              >
                <path
                  d="M0 12c0 6.627 5.373 12 12 12s12-5.373 12-12-5.373-12-12-12-12 5.373-12 12zm2 0c0-5.292 4.113-9.612 9.315-9.965-3.205 2.154-5.315 5.813-5.315 9.965s2.11 7.811 5.315 9.965c-5.202-.353-9.315-4.673-9.315-9.965z"
                ></path>
              </svg>
            </a-tooltip>
          </span>
        </div>
        <a-dropdown>
          <div class="service-dropdown">
            <h4>{{$auth.user().first_name}} {{$auth.user().last_name}}</h4>
            <h5>{{$auth.user().username}}</h5>
            <i class="zmdi zmdi-unfold-more"></i>
          </div>
          <a-menu slot="overlay">
            <a-menu-item>
              <a href="javascript:;">Billing Service</a>
            </a-menu-item>
            <a-menu-item>
              <a href="javascript:;">Time Tracking</a>
            </a-menu-item>
            <a-menu-item>
              <a href="javascript:;">User Management</a>
            </a-menu-item>
            <a-menu-item>
              <a href="javascript:;">Logout</a>
            </a-menu-item>
          </a-menu>
        </a-dropdown>
        <span class="padd text-opacity pl-2" style="padding-top:20px">MENU</span>
        <a-menu theme="dark" mode="inline" :defaultSelectedKeys="['1']">
          <a-menu-item key="1">
            <router-link :to="{name: 'home'}" style="color:black">
              <a-icon type="area-chart"/>
              <span>Dashboard</span>
            </router-link>
          </a-menu-item>
          <a-menu-item key="2">
            <router-link :to="{name: 'account-show'}" style="color:black">
              <a-icon type="user"/>
              <span>My Account</span>
            </router-link>
          </a-menu-item>
          <a-menu-item key="3" v-show="isAdmin">
            <router-link :to="{name: 'users'}" style="color:black">
              <a-icon type="solution"/>
              <span>Users</span>
            </router-link>
          </a-menu-item>
          <a-menu-item v-show="isAdmin" key="4">
            <router-link :to="{name: 'permissions'}" style="color:black">
              <a-icon type="cluster"/>
              <span>Permissions</span>
            </router-link>
          </a-menu-item>
          <a-menu-item key="5" v-show="isAdmin">
            <router-link :to="{name: 'roles'}" style="color:black">
              <a-icon type="crown"/>
              <span>Roles</span>
            </router-link>
          </a-menu-item>
          <a-sub-menu class="menu--dropdown" key="accesscontrol" v-show="isAdmin">
            <span slot="title" style="color:black">
              <a-icon type="fullscreen-exit"/>
              <span style="padding-left:14px; font-size:14px">Access Control Manager</span>
            </span>
            <a-menu-item key="99">
              <router-link
                :to="{name: 'users',query: {mode: 'access-control'}}"
                style="color:black"
              >
                <a-icon type="swap"/>Users to Roles
              </router-link>
            </a-menu-item>
            <a-menu-item key="100">
              <router-link
                :to="{name: 'permissions',query: {mode: 'access-control'}}"
                style="color:black"
              >
                <a-icon type="swap"/>Roles to Permissions
              </router-link>
            </a-menu-item>
          </a-sub-menu>
          <a-sub-menu class="menu--dropdown" key="sub4">
            <span slot="title" style="color:black">
              <a-icon type="setting"/>
              <span style="padding-left:14px; font-size:14px">Services</span>
            </span>
            <a-menu-item key="9">
              <a-icon type="euro"/>Billing Service
              <sup style="padding-left:4px; opacity:.3">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="12"
                  height="12"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="icon xlink"
                >
                  <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
                  <polyline points="15 3 21 3 21 9"></polyline>
                  <line x1="10" y1="14" x2="21" y2="3"></line>
                </svg>
              </sup>
            </a-menu-item>
            <a-menu-item key="10">
              <a-icon type="clock-circle"/>Time Tracking Service
              <sup style="padding-left:4px; opacity:.3">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="12"
                  height="12"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="icon xlink"
                >
                  <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
                  <polyline points="15 3 21 3 21 9"></polyline>
                  <line x1="10" y1="14" x2="21" y2="3"></line>
                </svg>
              </sup>
            </a-menu-item>
            <a-menu-item key="11">
              <a-icon type="file-done"/>Payroll Service
              <sup style="padding-left:4px; opacity:.3">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="12"
                  height="12"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="icon xlink"
                >
                  <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
                  <polyline points="15 3 21 3 21 9"></polyline>
                  <line x1="10" y1="14" x2="21" y2="3"></line>
                </svg>
              </sup>
            </a-menu-item>
          </a-sub-menu>
          <a-menu-item key="8" @click="logout" style="color:black">
            <a-icon style="transform:rotate(270deg)" type="upload"/>
            <span>Logout</span>
          </a-menu-item>
        </a-menu>
      </a-layout-sider>
      <a-layout>
        <a-layout-header style="background: #fff; padding: 0">
          <a-icon
            class="trigger"
            :type="collapsed ? 'menu-unfold' : 'menu-fold'"
            @click="toggleSidebar"
          />
          <ul class="fancy-nav">
            <li class>
              <ul class="search-menu">
                <li>
                  <form @submit.prevent="searchFilter">
                    <input
                      v-model="search"
                      @input="clearSearchCard"
                      class="search-bar"
                      :disabled="isAdmin === true ? false : true"
                      placeholder="Enter any term to search for Users, Permissions or Roles "
                    >
                    <small
                      @click="clearFilter"
                      v-if="this.search"
                      style="margin-left:-30px; cursor:pointer"
                    >
                      <a-icon type="close"/>
                    </small>
                    <small @click="clearFilter" v-else style="margin-left:-30px; cursor:pointer">
                      <a-icon type="search"/>
                    </small>
                    <input type="submit" style="position: absolute; left: -9999px">
                  </form>
                </li>
                <li v-show="showSearchCard">
                  <a-card class="search-results" style="padding:0px !important">
                    <button @click="clearFilter" class="clear-filter">Clear Filter</button>
                    <br>
                    <center v-show="isLoading">
                      <a-spin class="text-center"/>
                    </center>
                    <ul class="inline-menu">
                      <li
                        v-if="searchResults && searchResults.users && searchResults.users.data && searchResults.users.data.length === 0 && searchResults && searchResults.roles && searchResults.roles.data && searchResults.roles.data.length === 0 && searchResults && searchResults.permissions && searchResults.permissions.data && searchResults.permissions.data.length === 0"
                        style="display:inherit"
                      >
                        <center>
                          <span
                            class="text-opacity"
                            style="text-align:center"
                          >No Results found for your Entry, Please Crosscheck and try again</span>
                        </center>
                      </li>
                      <li v-else>
                        <h5 class="text-opacity">Users</h5>
                        <ul
                          v-if="searchResults.users && searchResults.users.data.length > 0"
                          class="search-list"
                          style="margin-top:5px"
                        >
                          <li
                            @click="clearFilter"
                            :key="index"
                            v-for="(user,index) in searchResults.users.data"
                          >
                            <a-row>
                              <a-col :span="20" style=" padding-top:7px">
                                <router-link :to="{name: 'users-show',params: {id: user.id}}">
                                  <span
                                    style="font-size:14px;"
                                  >{{ user.first_name }} {{ user.last_name }}</span>
                                  <h6 class="text-opacity">{{user.email}}</h6>
                                </router-link>
                              </a-col>
                              <a-col :span="3">
                                <span class="more-icon">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="12"
                                    height="12"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    class="icon xlink"
                                  >
                                    <path
                                      d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"
                                    ></path>
                                    <polyline points="15 3 21 3 21 9"></polyline>
                                    <line x1="10" y1="14" x2="21" y2="3"></line>
                                  </svg>
                                </span>
                                <h6 class="text-purple">Checkout</h6>
                              </a-col>
                            </a-row>
                          </li>
                        </ul>
                        <ul class="search-list" style="margin-top:5px" v-else>
                          <li>
                            <small class="text-opacity">No Users for Search term</small>
                          </li>
                        </ul>

                        <h5 class="text-opacity pt-4">Permissions</h5>
                        <ul
                          class="search-list"
                          style="margin-top:5px"
                          v-if="searchResults.permissions && searchResults.permissions.data.length > 0"
                        >
                          <li
                            @click="clearFilter"
                            :key="index"
                            v-for="(permission,index) in searchResults.permissions.data"
                          >
                            <router-link
                              :to="{name: 'permissions-show', params: {xid: permission.id}}"
                            >
                              <a-row>
                                <a-col :span="7">
                                  <small class="text-opacity">Name</small>
                                  <h4>{{ permission.name }}</h4>
                                </a-col>
                                <a-col :span="7">
                                  <small>Service</small>
                                  <h4
                                    class="long-text text-opacity"
                                  >{{ permission.service ? permission.service: 'Not Assigned' }}</h4>
                                </a-col>
                                <a-col :span="7" class="pl-4">
                                  <small class="text-opacity">Status</small>
                                  <h4 v-if="permission.active">
                                    <a-badge status="success"/>Active
                                  </h4>
                                  <h4 v-else>
                                    <a-badge status="error"/>InActive
                                  </h4>
                                </a-col>
                                <a-col :span="3">
                                  <span>
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="12"
                                      height="12"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      stroke-width="2"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                      class="icon xlink"
                                    >
                                      <path
                                        d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"
                                      ></path>
                                      <polyline points="15 3 21 3 21 9"></polyline>
                                      <line x1="10" y1="14" x2="21" y2="3"></line>
                                    </svg>
                                  </span>
                                  <h6 class="text-purple">Checkout</h6>
                                </a-col>
                              </a-row>
                            </router-link>
                          </li>
                        </ul>
                        <ul class="search-list" style="margin-top:5px" v-else>
                          <li>
                            <small class="text-opacity">No Permissions for Search term</small>
                          </li>
                        </ul>

                        <h5 class="text-opacity pt-4">Roles</h5>
                        <ul
                          class="search-list"
                          style="margin-top:5px"
                          v-if="searchResults.roles && searchResults.roles.data.length > 0"
                        >
                          <li
                            @click="clearFilter"
                            :key="index"
                            v-for="(role,index) in searchResults.roles.data"
                          >
                            <router-link :to="{name: 'roles-show', params: {id: role.id}}">
                              <a-row>
                                <a-col :span="13">
                                  <small class="text-opacity">Name</small>
                                  <h4>{{ role.name }}</h4>
                                </a-col>
                                <a-col :span="7" class="pl-4">
                                  <small class="text-opacity">Status</small>
                                  <h4 v-if="role.active">
                                    <a-badge status="success"/>Active
                                  </h4>
                                  <h4 v-else>
                                    <a-badge status="error"/>InActive
                                  </h4>
                                </a-col>
                                <a-col :span="3" style="padding-top:5px">
                                  <span>
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="12"
                                      height="12"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      stroke-width="2"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                      class="icon xlink"
                                    >
                                      <path
                                        d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"
                                      ></path>
                                      <polyline points="15 3 21 3 21 9"></polyline>
                                      <line x1="10" y1="14" x2="21" y2="3"></line>
                                    </svg>
                                  </span>
                                  <h6 class="text-purple">Checkout</h6>
                                </a-col>
                              </a-row>
                            </router-link>
                          </li>
                        </ul>
                        <ul class="search-list" style="margin-top:5px" v-else>
                          <li>
                            <small class="text-opacity">No Roles for Search term</small>
                          </li>
                        </ul>
                      </li>
                    </ul>
                    <div
                      v-show="searchResults && searchResults.users && searchResults.users.data && searchResults.users.data.length > 0 || searchResults && searchResults.roles && searchResults.roles.data && searchResults.roles.data.length > 0 || searchResults && searchResults.permissions && searchResults.permissions.data && searchResults.permissions.data.length > 0"
                      class="scroll-text"
                    >Scroll Down to See more Results</div>
                  </a-card>
                </li>
              </ul>
            </li>
            <a-dropdown>
              <li class="fancy-nav--right" style="cursor:pointer" @click="showNotificationDrawer">
                <i class="notification-amount"/>
                <i
                  id="notifications"
                  class="zmdi left-sidebar-menu zmdi-notifications-none z-menu float-left"
                />
              </li>
            </a-dropdown>
            <a-dropdown class="profile-dropdown">
              <li class="fancy-nav--right" style="cursor:pointer">
                <img
                  src="@/assets/img/profilepic.jpeg"
                  style="height:30px; width:30px;border-radius:30px"
                >
              </li>
               
            </a-dropdown>

            <li></li>
          </ul>
        </a-layout-header>
        <a-layout-content
          :style="{ margin: '24px 16px', padding: '24px', background: '#fff', minHeight: '280px' }"
        >
          <router-view/>
        </a-layout-content>
      </a-layout>
    </a-layout>
  </div>
</template>

<script>
import "./assets/css/style.scss";
import AuthNav from "@/components/Layouts/AuthNav/Index.vue";
import NewEntryModal from "@/components/Modals/NewEntry";
import NotificationsDrawer from "@/components/Drawers/Notifications";
import isAdmin from "@/mixins/isAdmin";
export default {
  data() {
    return {
      collapsed: false,
      search: "",
      showSearchCard: false,
      api: this.$baseApi,
      searchResults: [],
      isLoading: true,
      visible: false,
      showSidebar: false,
      entryModal: false
    };
  },
  components: { AuthNav, NewEntryModal, NotificationsDrawer },
  mixins: [isAdmin],
  methods: {
    clearSearchCard() {
      if (this.search === "") {
        this.showSearchCard = false;
      }
    },
    hideEntryModal(b) {
      this.entryModal = b;
    },
    showEntryModal() {
      this.entryModal = true;
    },
    showNotificationDrawer() {
      this.$refs.notificationDrawer.showDrawer();
    },
    verifyUser() {
      let valid = [
        "login",
        "register",
        "forgot-password",
        "reset-password",
        "verify-email"
      ];
      if (valid.includes(this.$route.name)) {
        return true;
      }
      return false;
    },
    clearFilter() {
      this.search = "";
      this.showSearchCard = false;
    },
    showServices() {
      this.visible = true;
    },
    searchFilter() {
      this.showSearchCard = true;
      const url = `${this.api}/dashboard/search`;
      this.$http
        .get(url, { params: { search: this.search } })
        .then(s => {
          this.isLoading = false;
          this.showSearchCard = true;
          this.searchResults = s.data;
        })
        .catch(() => {
          this.showSearchCard = true;
        });
    },
    toggleSidebar() {},
    logout() {
      this.$auth.logout({
        makeRequest: true,
        params: {}, // data: {} in axios
        success: function() {},
        error: function() {},
        redirect: "/login"
        // etc...
      });
    }
  },
  mounted() {
   
  }
};
</script>

<style lang="scss">
$primary-color: #2d1cbc;
div {
  &.preloader {
    position: fixed;
    width: 100%;
    background: white;
    height: 100vh;
    margin: 0 auto;
    z-index: 9999999999;
    text-align: center;

    .container {
      margin-top: 45vh;
    }
  }
}
ul.search-menu {
  display: inline-grid;

  li {
    .search-results {
      width: 40vw;
      margin-top: 15px;
      position: absolute;
      z-index: 999999;
      border: 0px;
      height: auto;
    }
  }
}
div.search-results {
  .ant-card-body {
    padding-left: 0px;
    max-height: 350px;
    overflow-y: scroll;
    padding-right: 0px;
    width: 100%;

    .scroll-text {
      position: absolute;
      z-index: 9999;
      bottom: 0;
      background: #f7f7f7;
      width: 100%;
      font-size: 12px;
      padding: 10px;
      text-align: center;
    }
  }
}
ul {
  &.inline-menu {
    padding-left: 20px;
    li {
      display: inline-grid;
      width: 100%;
      ul {
        padding-left: 0;
      }

      h5 {
        padding-left: 10px;
      }
    }
  }
  &.search-list {
    margin-bottom: 20px !important;
    margin-right: 10px !important;
    li {
      a {
        color: black;
      }
      width: 100%;
      padding-top: 10px;
      padding-bottom: 10px;
      padding-left: 10px;
      cursor: pointer;
      &:hover {
        background: #f7f7f7;

        h6,
        span,
        h4 {
          color: $primary-color;
          &.more-icon {
            color: $primary-color;
          }
        }
      }

      div {
        h4 {
          font-size: 14px;
        }
      }
    }
  }
}
#components-layout-demo-custom-trigger .trigger {
  font-size: 18px;
  line-height: 64px;
  padding: 0 24px;
  cursor: pointer;
  transition: color 0.3s;
}
.outer-sidebar {
  max-width: 50px !important;
  min-width: 50px !important;
  width: 50px !important;
  background: linear-gradient(180deg, #594cca, #2d1cbc) !important;
  position: fixed;
  z-index: 99;
}
.inner-sidebar {
  min-width: 300px !important;
  /* width: 250px !important; */
  background: #f7f8fc;
  flex: 0 0 300px;
  border-right: 2px solid #efefef;
  margin-left: 60px;
  height: 100vh;

  .ant-layout-sider-children {
    position: fixed;
    width: 297px;
  }
}
h4 {
  &.long-text {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
.ant-menu-dark.ant-menu-inline,
.ant-menu-dark.ant-menu-vertical,
.ant-menu-dark.ant-menu-vertical-left,
.ant-menu-dark.ant-menu-vertical-right {
  background: #f7f8fc;
}
ul.ant-menu > li.ant-menu-item {
  color: black;
}
button {
  &.clear-filter {
    font-size: 10px;
    background: #f7f7f7;
    border: 0px;
    border-radius: 10px;
    float: right;
    margin-right: 10px;
  }
}
#components-layout-demo-custom-trigger .trigger:hover {
  color: #1890ff;
}

#components-layout-demo-custom-trigger .logo {
  height: 32px;
  background: rgba(255, 255, 255, 0.2);
  margin: 16px;
}
.ant-layout-sider-children {
  height: 100vh;
}
</style>


